interface SurveyText {
  Id: string
  Language__c: string
  Text__c: string
  Text_Is_Portal_Translation_Id__c: string
}

export const surveyTranslationFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Survey_Texts__r: 'surveyTexts'
}

export interface SurveyTranslation {
  id: string
  surveyTexts?: {
    records: SurveyText[]
    totalSize: number
    done: boolean
  }
}
